import s from './style.module.scss'
import clsx from 'clsx'

const CardVerticalShimmer = ({className}: {className?: string}) => {
  return <div className={clsx(s.card, s.shimmer, className)} />
}

export default CardVerticalShimmer
